module.exports = __webpack_public_path__ + "static/media/banner.62b9d931.svg";